/**
 * Feed dos comandos recentes do aparelho selecionado.
 *
 * Responsabilidade: mostrar o que foi mandado e o que voltou.
 *
 * NAO e responsabilidade deste arquivo: mandar comando (`acoes.ts`).
 *
 * ## Por que este painel existe
 *
 * Um comando pela nuvem tem tres desfechos e nenhum deles e imediato:
 * publicado (`sent_at`), confirmado (`acked_at` com `ok`), ou pendente para
 * sempre — o aparelho pode estar offline e o broker guarda a mensagem ate ele
 * voltar (`clean_session=false`, contrato §3). Sem este feed, a tela mostraria
 * o botao apertado e nada mais, e "nao aconteceu ainda" ficaria
 * indistinguivel de "nao vai acontecer".
 *
 * `dup: true` e o aparelho dizendo que ja tinha executado aquele ULID —
 * cláusula 4, o ring de dedup na RAM dele. Aparece como tal, e nao como erro.
 */

import * as store from "./../store";
import type { CommandOut } from "./../tipos";
import { dataHora, el, trocar, type Painel } from "./../ui";

export function montar(): Painel {
  const lista = el("div", { class: "lista-comandos" });
  const raiz = el(
    "section",
    { class: "panel card", id: "comandos" },
    el(
      "div",
      { class: "panel-head" },
      el("span", { class: "panel-title", text: "Comandos" }),
    ),
    lista,
  );

  function atualizar(): void {
    const alvo = store.aparelhoSelecionado();
    const comandos = alvo === null ? [] : (store.obter().comandos[alvo.device.id] ?? []);
    if (comandos.length === 0) {
      trocar(lista, el("p", { class: "hint", text: "Nenhum comando ainda." }));
      return;
    }
    trocar(lista, ...comandos.slice(0, 8).map(linha));
  }

  return { raiz, atualizar };
}

function linha(comando: CommandOut): HTMLElement {
  const { rotulo, classe } = desfecho(comando);
  return el(
    "div",
    { class: "comando" },
    el(
      "div",
      { class: "comando-corpo" },
      el("span", { class: "comando-cmd", text: `${comando.cmd} ${comando.key}`.trim() }),
      comando.value !== "" && el("span", { class: "comando-valor", text: comando.value }),
    ),
    el(
      "div",
      { class: "comando-meta" },
      el("span", { class: `selo ${classe}`, text: rotulo }),
      el("span", { class: "hint", text: dataHora(comando.created_at) }),
    ),
  );
}

function desfecho(comando: CommandOut): { rotulo: string; classe: string } {
  if (comando.acked_at === null) {
    return comando.sent_at === null
      ? { rotulo: "não enviado", classe: "erro" }
      : { rotulo: "aguardando o aparelho", classe: "pendente" };
  }
  if (comando.ok === false) {
    return { rotulo: comando.err ?? "recusado", classe: "erro" };
  }
  return comando.dup
    ? { rotulo: "já estava aplicado", classe: "ok" }
    : { rotulo: "aplicado", classe: "ok" };
}
